import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    height: `calc(100% - ${theme.spacing.spacing28})`,
    alignItems: "flex-start",
    overflowY: "auto",
  },
  text: {
    display: "flex",
    fontSize: theme.typography.size.xs,
    lineHeight: "18px",
    margin: `${theme.spacing.spacing3} 0 ${theme.spacing.spacing2} 0`
  },
  textBullet: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightBold,
  },
  youTubeContainer: {
    display: "flex",
    width: theme.width.full,
    justifyContent: "center",
    marginTop: theme.spacing.spacing10,
  },
  iframeClassName: {
    borderRadius: theme.borders.borderRadius.lg,
    width: theme.width.full,
  },
  innerStep2Container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: theme.width.full,
    height: `calc(100% - ${theme.spacing.spacing5})`,
    justifyContent: "space-around",
  },
  sandClockContainer: {
    margin: `${theme.spacing.spacing33} 0 ${theme.spacing.spacing8} 0`,
    display: "contents",
    alignItems: "center",
  },
  timerText1: {
    marginBottom: theme.spacing.spacing25,
    textAlign: "center",
  },
  toastContainer: {
    position: "fixed",
    width: theme.width.full,
    top: 80,
    left: theme.spacing.spacing4,
    bottom: theme.spacing.spacing4,
  },
});

export const getToastStyles = (theme: Theme): Styles => ({
  fontFamily: "Nunito Sans, sans-serif",
  position: "fixed",
  top: 80,
  left: 0,
  height: 100,
  width: `calc(100% - ${theme.spacing.spacing10})`,
  textAlign: "center",
  background: theme.palette.black.main,
  color: theme.palette.white.main,
  borderRadius: 10,
  fontSize: theme.typography.size.xs,
  fontWeight: theme.typography.fontWeightMedium,
  margin: `0 ${theme.spacing.spacing5}`,
});
